import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

function counterFunction() {
	if($('.wp-block-keztablocks-counters').length) {
		$('.wp-block-keztablocks-counters').each(function() {
		    var self = $(this),
		        bar = self.find('.wp-block-keztablocks-counter');
		    bar.each(function() {
			    var count = $(this).find('.wp-block-keztablocks-counter__number'),
			        zero = {val:0},
			        num = count.data("number"),
			        split = (num + "").split("."),
			        decimals = split.length > 1 ? split[1].length : 0;

			    gsap.to(zero, {
					scrollTrigger: {
					    trigger: self[0],
						start: "+=100 bottom",
					},
					duration: 2,
					val: num,
					onUpdate: function() {
			            count.text(zero.val.toFixed(decimals));
			        }
				});
			});
		});
	}
}
function socialFunction() {
	if($(".wp-block-keztablocks-counter").length > 0) {
		$(".wp-block-keztablocks-counter").each(function() {
			var self = $(this),
			    dataHoverBgColor = self.attr("data-hbgcolor"),
			    dataHoverBorColor = self.attr("data-hborcolor"),
			    tl = gsap.timeline({paused:true});
			var tween = gsap.to(self, {duration:0.3, backgroundColor: dataHoverBgColor, borderColor: dataHoverBorColor,paused:true, ease:"none"});

			self.on("mouseenter", () => {
				tween.play();
			}).on("mouseleave", () => {
				tween.reverse();
			})
		})
	}
}
$(window).on('load', () => {
  if($('.c-loader').length) {
    setTimeout(() => { 
          counterFunction();
      }, 3200);
  } else {
    setTimeout(() => { 
          counterFunction();
      }, 400);
  }
  socialFunction()
})